import React, { useEffect, useState } from 'react'
import { ajaxGet, patchForm, postForm, ajaxDelete } from '../../../ajax'
import Modal from 'react-bootstrap-modal'
import FlashAlert from '../../../components/flash-alert'
import { useForm } from 'react-hook-form'
import NumberInput from './number-input'
import SelectInput from './select-input'
import DateSelect from './date-select'
import TextArea from './text-area'
import MultiSelect from './multi-select'
import moment from 'moment'

const ReconcileModal = props => {
  const [facilityPay, setFacilityPay] = useState()
  const [alert, setAlert] = useState()
  const [isLoading, setIsLoading] = useState(true)

  const { register, reset, setValue, handleSubmit, control, formState: { errors } } = useForm()

  const paymentTypes = [
    '', 'Daily', 'Weekly', 'Monthly', 'Pending Payment', 'CC', 
    'CC Pending', 'Melio', 'Zelle', 'Bi-Weekly', 'Free Game'
  ]
  const captainPaymentTypes = ['', 'Cash App', 'Venmo', 'Zelle', 'Paypal', 'Pending Payment', 'No Captain', 'Free Captain', 'No Pay (See Notes)']
  const multiPaymentTypes = captainPaymentTypes.map(val => ({value: val, label: val}))

  useEffect(() => {
    loadFacilityPay()
  }, [])

  useEffect(() => {
    if (facilityPay) {
      reset(_.omit(facilityPay, 'id', 'game_id'))
      if (facilityPay.captain_payment_type) {
        const captainPaymentType = facilityPay.captain_payment_type.split(', ').map(p => ({ value: p, label: p }))
        setValue('captain_payment_type', captainPaymentType)
      }
    }
  }, [facilityPay])

  const loadFacilityPay = () => {
    ajaxGet(`/admins/games/${props.gameId}/facility_pay/edit.json`)
    .then(response => { if (response.ok) return response.json() })
    .then(json => {
      setFacilityPay(json.facility_pay)
      setIsLoading(false)
    })
  }

  const destroyFacilityPay = () => {
    ajaxDelete(`/admins/games/${props.gameId}/facility_pay`)
    .then(response => { if (response.ok) return response.json() })
    .then(json => {
      if (json.alert)
        setAlert(json.alert)
      else {
        props.onUpdateFacilityPay(json.facility_pay)
        props.onClose()
      }
    })
  }

  const onSubmit = (data) => {
    let formData = new FormData()
    for (const key in data) {
      if (data[key] != null && data[key] != undefined) formData.append(`facility_pay[${key}]`, data[key])
      if (key == 'captain_payment_type' && data[key]) {
        const captainPaymentType = data[key].map(v => v.label).join(', ')
        formData.append(`facility_pay[${key}]`, captainPaymentType)
      }
    }

    const formMethod = facilityPay.id ? patchForm : postForm

    formMethod(`/admins/games/${props.gameId}/facility_pay`, formData)
    .then(response => { return response.json() })
    .then(json => {
      if (json.alert)
        setAlert(json.alert)
      else {
        props.onUpdateFacilityPay(json.facility_pay)
        props.onClose()
      }
    })
  }

  if (!facilityPay) return null

  return (
    <Modal dialogClassName={`reconcile-modal ${isLoading ? ' isLoading' : ''}`} container={document.body} show={true} onHide={props.onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Reconcile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} />}
        { isLoading && <div className='animated-spinner' /> }
        <form onSubmit={handleSubmit(onSubmit)}>
          <NumberInput
            {...register('paid_amount', {
              required: 'Is required',
              min: { value: 0, message: 'Must be >= 0' },
              max: { value: 1000000, message: 'Must be <= 1000000' }
            })}
            label='Plei Paid'
            error={errors && errors.paid_amount}
            onChange={e => setValue('paid_amount', e.target.value, { shouldValidate: true })}
          />
          <SelectInput
            {...register('payment_type', { required: 'Is required' })}
            label='How Did We Pay?'
            options={paymentTypes}
            error={errors && errors.payment_type}
            onChange={e => setValue('payment_type', e.target.value, { shouldValidate: true })}
          />
          <DateSelect
            control={control}
            name='paid_at'
            label='When Did We Pay?'
          />
          <TextArea
            {...register('notes')}
            name='notes'
            label='Notes'
            rows='5'
            onChange={e => setValue('notes', e.target.value)}
          />

          <div className='separator'></div>

          <NumberInput
            {...register('captain_paid_amount', {
              min: { value: 0, message: 'Must be >= 0' },
              max: { value: 1000000, message: 'Must be <= 1000000' }
            })}
            label='Captain Pay'
            error={errors && errors.captain_paid_amount}
            onChange={e => setValue('captain_paid_amount', e.target.value, { shouldValidate: true })}
          />
          <MultiSelect
            control={control}
            name='captain_payment_type'
            label='Captain - How Did We Pay?'
            options={multiPaymentTypes}
          />
          <DateSelect
            control={control}
            name='captain_paid_at'
            label='Captain - When Did We Pay?'
          />
          <TextArea
            {...register('captain_notes')}
            name='captain_notes'
            label='Captain Notes'
            rows='5'
            onChange={e => setValue('captain_notes', e.target.value)}
          />
          <div className='buttons-container'>
            <input type='submit' value='Save' className='btn btn-primary' />
            { facilityPay && facilityPay.game_id &&
              <input type='button' className='btn btn-danger delete-facility-pay' onClick={destroyFacilityPay} value='Delete' />
            }
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}

export default ReconcileModal
